import { render, staticRenderFns } from "./BusinessLicense.vue?vue&type=template&id=3fa24c68&scoped=true&"
import script from "./BusinessLicense.vue?vue&type=script&lang=js&"
export * from "./BusinessLicense.vue?vue&type=script&lang=js&"
import style0 from "./BusinessLicense.vue?vue&type=style&index=0&id=3fa24c68&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa24c68",
  null
  
)

export default component.exports